window.theme = window.theme || {};
window.theme.RS = window.theme.RS || {};

window.theme.RS.FooterNewsletter = (function() {
  var Footer = {};
  var loadedEvent = new CustomEvent('RS:FooterNewsletter:loaded');
  var HIDE_CLASS = 'rs-invisible';
  var SHOW_CLASS = 'rs-visible';
  var ERROR_CLASS = 'error';
  var ERROR_SELECTOR = '.footer__newsletter-error';
  var INPUT_CONT_SEL = '[data-input]';
  var DEFAULT_ERROR_SEL = '[data-default-err]';
  var ATTENTIVE_SUBSCRIBE = '/api/v1/attentive';
  var ATTENTIVE_SUBMIT_TRIGGER = '[data-action="attentive-submit"]';
  var ATTENTIVE_FORM_SELECTOR ='.attentive-mobile-form';
  var ATTENTIVE_DEFAULT_ERROR = window.theme.strings.attentive.subscriptions.form.errors.submitDefault;
  var ATTENTIVE_PHONE_ERROR = window.theme.strings.attentive.subscriptions.form.errors.phone;
  var KLAVIYO_SUBMIT_TRIGGER = '[data-action="klaviyo-submit"]';
  var KLAVIYO_FORM_SELECTOR = '.klaviyo-form';
  var SUCCESS_MSG_SELECTOR = '.footer__newsletter--success';
  var KLAVIYO_DEFAULT_ERROR = window.theme.strings.klaviyo.subscriptions.form.errors.submitDefault;
  var SUBMIT_DISABLE_CLASS = 'disabled';

  Footer.getExternalAppUrl = function getExternalAppUrl() {
    var url = '';
    if (window.theme.themeSettings && window.theme.themeSettings.roswell_ext_url) {
      url = window.theme.themeSettings.roswell_ext_url;
    }

    return url;
  };

  Footer.convertFormData = function convertFormData(formData) {
    var data = {};
   
    if (formData && formData.entries) {
      for(var pair of formData.entries()) {
        data[pair[0]] =  pair[1];
      }
    }
    return data;
  };
  Footer.initFooterSignUp = function initFooterSignUp(containerSelector){

    var container = containerSelector ? document.querySelector(containerSelector) : null;

    if (container) {
      var hiddenClass = 'fine-print--hidden'
      var mobileForm = container.querySelector('.attentive-mobile-form-wrapper');
      var emailForm = container.querySelector('.klaviyo-email-form-wrapper');
      var emailInput = container.querySelector('.footer__newsletter--input');
      var emailFinePrint = container.querySelector('.email-fine-print-wrapper');
      var mobileInput = container.querySelector('.footer__newsletter--mobile--input');
      var mobileFinePrint = container.querySelector('.mobile-fine-print-wrapper');
      var inputEmailBorder = container.querySelector('.email-input');
      var inputMobileBorder = container.querySelector('.phone-input');

      var setHeights = function() {
        var heightEmailFP = emailFinePrint.offsetHeight;
        var visibleEmailHeight = heightEmailFP + "px";
        var heightMobileFP = mobileFinePrint.offsetHeight;
        var visibileMobileHeight = heightMobileFP + "px";

        emailFinePrint.style.height = visibleEmailHeight;
        emailFinePrint.classList.add(hiddenClass);
  
        mobileFinePrint.style.height = visibileMobileHeight;
        mobileFinePrint.classList.add(hiddenClass);
      };

      var displayFinePrint = function () {
        // Setup focus event delegation for this container
        Footer.setupFinePrintDelegation(container, {
          emailInput: emailInput,
          emailFinePrint: emailFinePrint,
          inputEmailBorder: inputEmailBorder,
          mobileInput: mobileInput,
          mobileFinePrint: mobileFinePrint,
          inputMobileBorder: inputMobileBorder,
          emailForm: emailForm,
          mobileForm: mobileForm,
          hiddenClass: hiddenClass
        });
      }

      setHeights();
      displayFinePrint();
    }
  };

  Footer.toggleHideClass = function toggleHideClass(show, elem) {
    if (elem) {
      if (show) {
        elem.classList.add(SHOW_CLASS);
        elem.classList.remove(HIDE_CLASS);
      } else {
        elem.classList.add(HIDE_CLASS);
        elem.classList.remove(SHOW_CLASS);
      }
    }
  }

  Footer.resetErrors = function resetErrors(form) {
    var inputcontainers = form ? Array.from(form.querySelectorAll(INPUT_CONT_SEL)) : [];
    var errorContainers = inputcontainers.filter(function(input) {
      return input.classList.contains(ERROR_CLASS);
    });
   
    errorContainers.forEach(function(container) {
      var error = container.querySelector(ERROR_SELECTOR);
      var defaultMsg = ATTENTIVE_DEFAULT_ERROR;
      container.classList.remove(ERROR_CLASS);
      if (error) {
        if (error.dataset.errMsgDefault) {
          defaultMsg = error.dataset.errMsgDefault;
        }
        Footer.toggleHideClass(false, error);

        if (error.innerText !== defaultMsg) {
          error.innerText = error.dataset.errMsgDefault;
        }
      }
    });

    return inputcontainers;

  };

  Footer.validateForm = function validateForm(form) {
    var isValid = true;
    var inputcontainers = Footer.resetErrors(form);
    var len = inputcontainers ? inputcontainers.length : 0;
    var container,
        input,
        inputError,
        errorMsg,
        isRequired,
        defaultMsg,
        regex;

    if (form) {
      for (var i = 0; i < len; i++) {
        container = inputcontainers[i];
        input = container.querySelector('[name="' + container.dataset.input + '"]');
        inputError = container.querySelector(ERROR_SELECTOR);
        
        if (!input) {
          isValid = false;
        } else {
          defaultMsg = inputError.dataset.errMsgDefault || '';
          isRequired = input.required;

          if (input.type === 'checkbox') {
            if (isRequired && !input.checked) {
              isValid = false;
            }
          } else if (isRequired && !input.value) {
            isValid = false;
            errorMsg = inputError.dataset.errMsgRequired;
          } else if (input.dataset.pattern) {
            regex = new RegExp(input.dataset.pattern);

            if (!input.value.match(regex)) {
              isValid = false;
              errorMsg = inputError.dataset.errMsgPattern;
            }
          }
        }

        if (!isValid) {
          errorMsg = errorMsg ? errorMsg : defaultMsg;
          if (errorMsg && inputError.innerText !== errorMsg) {
            inputError.innerText = errorMsg;
          }
          container.classList.add(ERROR_CLASS);
          if (inputError) {
            Footer.toggleHideClass(true, inputError);

          }
          break;
        }
      }
    } else {
      isValid = false;
    }

    return isValid;
  };

  Footer.toggleSubmitDisable = function toggleSubmitDisable(target, isDisabled) {
    if (target) {
      if (isDisabled) {
        target.classList.add(SUBMIT_DISABLE_CLASS);
      } else {
        target.classList.remove(SUBMIT_DISABLE_CLASS);
      }
    }
  };

  Footer.attentiveOnSubmitError = function attentiveOnSubmitError(error, form) {
    var msg = ATTENTIVE_DEFAULT_ERROR;
    var errorMsg = error ? error.message : '';
    var errorElem = form ? form.querySelector(DEFAULT_ERROR_SEL) : null;
    var container = errorElem ? errorElem.closest(INPUT_CONT_SEL) : null;

    if (error) {
      if (container && errorElem) {
        if (error.status === 400 && errorMsg) {
          if ((errorMsg).toLowerCase() === 'bad request') {
            msg = ATTENTIVE_PHONE_ERROR;
          } else {
            msg = errorMsg || ATTENTIVE_DEFAULT_ERROR;
          }
        }

        errorElem.innerText = msg;
        container.classList.add(ERROR_CLASS);
        Footer.toggleHideClass(true, errorElem);
      }
    }
  };

  Footer.klaviyoOnSubmitError = function klaviyoOnSubmitError(form) {
    var msg = KLAVIYO_DEFAULT_ERROR;
    var errorElem = form ? form.querySelector(DEFAULT_ERROR_SEL) : null;
    var container = errorElem ? errorElem.closest(INPUT_CONT_SEL) : null;

    if (container && errorElem) {
      errorElem.innerText = msg;
      container.classList.add(ERROR_CLASS);
      Footer.toggleHideClass(true, errorElem);
    }
  };

  Footer.sumbitSuccess = function attentiveSubmitSuccess(form) {
    var parent = form ? form.parentNode : null;
    var successElem = parent ? parent.querySelector(SUCCESS_MSG_SELECTOR) : null;
    if (successElem) {
      form.classList.add('hidden');
      Footer.toggleHideClass(true, successElem);
    }
  };

  Footer.attentiveSubmitHandler = function attentiveSubmitHandler(e, target, form) {
    var formData = {};
    var extUrl = Footer.getExternalAppUrl();
    e.preventDefault();

    Footer.toggleSubmitDisable(target, true);

    if (Footer.validateForm(form) && extUrl) {
      formData = Footer.convertFormData(new FormData(form));
      var data = {
        user: {
          phone: formData.phone
        },
        signUpSourceId: formData.signUpSourceId
      }

      fetch(
        extUrl + ATTENTIVE_SUBSCRIBE,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        }
      )
      .then(function(response) {
          return response.json();
      })
      .then(function(data) {
        Footer.toggleSubmitDisable(target);
        if (data) {
          Footer.resetErrors(form);

          if (data.error) {
            Footer.attentiveOnSubmitError(data.error, form);
          } else {
            Footer.sumbitSuccess(form);
          }
        }
      })
      .catch(function(error) {
        console.error('Error: ', error);
        Footer.attentiveOnSubmitError({}, form);
        Footer.toggleSubmitDisable(target);
      });
    } else {
      Footer.toggleSubmitDisable(target);
    }
  };

  Footer.klaviyoSubmitHandler = function klaviyoSubmitHandler(e, target, form) {
    var formData = {};
    e.preventDefault();

    Footer.toggleSubmitDisable(target, true);

    if (Footer.validateForm(form)) {
      formData = Footer.convertFormData(new FormData(form));

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=HsE2Re',
        {
          method: 'POST',
          headers: { revision: '2024-02-15', 'content-type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: formData.email
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: formData.g
                  }
                }
              }
            }
          })
        }
      )
      .then(function(response) {
        // There doesn't seem to be a response body to parse
        Footer.toggleSubmitDisable(target);

        if (response) {
          Footer.resetErrors(form);

          if (!response.ok) {
            Footer.klaviyoOnSubmitError(form);
          } else {
            Footer.sumbitSuccess(form);

            if (window.klaviyo && klaviyo.push) {
              klaviyo.push(["identify", { $email: formData.email || '' }]);
              klaviyo.push(["trackActivity"]);
            }

          }
        }
      })
      .catch(function(error) {
        console.error('Error: ', error);
        Footer.toggleSubmitDisable(target);
      });
    } else {
      Footer.toggleSubmitDisable(target);
    }
  };

  // Setup fine print event delegation for a specific container
  Footer.setupFinePrintDelegation = function setupFinePrintDelegation(container, elements) {
    if (!container || Footer._finePrintSetup) {
      return;
    }
    Footer._finePrintSetup = true;
    
    // Use event delegation for focus events
    document.addEventListener('focus', function(e) {
      if (e.target.matches('.footer__newsletter--input')) {
        var emailInput = e.target;
        var containerEl = emailInput.closest('#signup-container-desktop, #signup-container-mobile');
        if (containerEl) {
          var emailFinePrint = containerEl.querySelector('.email-fine-print-wrapper');
          var inputEmailBorder = containerEl.querySelector('.email-input');
          
          if (emailFinePrint && inputEmailBorder) {
            emailFinePrint.classList.add('fade-in-text'); 
            emailFinePrint.classList.remove(elements.hiddenClass);
            inputEmailBorder.classList.add('border');
          }
        }
      }
      
      if (e.target.matches('.footer__newsletter--mobile--input')) {
        var mobileInput = e.target;
        var containerEl = mobileInput.closest('#signup-container-desktop, #signup-container-mobile');
        if (containerEl) {
          var mobileFinePrint = containerEl.querySelector('.mobile-fine-print-wrapper');
          var inputMobileBorder = containerEl.querySelector('.phone-input');
          
          if (mobileFinePrint && inputMobileBorder) {
            mobileFinePrint.classList.add('fade-in-text');
            mobileFinePrint.classList.remove(elements.hiddenClass);
            inputMobileBorder.classList.add('border');
          }
        }
      }
    }, true);

    // Use event delegation for click events to hide fine print
    document.addEventListener('click', function(e) {
      var emailForm = document.querySelector('.klaviyo-email-form-wrapper');
      var mobileForm = document.querySelector('.attentive-mobile-form-wrapper');
      
      if (emailForm && !emailForm.contains(e.target)) {
        var emailFinePrint = emailForm.querySelector('.email-fine-print-wrapper');
        var inputEmailBorder = emailForm.querySelector('.email-input');
        var klaviyoForm = emailForm.querySelector(KLAVIYO_FORM_SELECTOR);
        
        if (emailFinePrint && inputEmailBorder) {
          emailFinePrint.classList.remove('fade-in-text'); 
          inputEmailBorder.classList.remove('border');
          emailFinePrint.classList.add(elements.hiddenClass);
          if (klaviyoForm) {
            Footer.resetErrors(klaviyoForm);
          }
        }
      }
      
      if (mobileForm && !mobileForm.contains(e.target)) {
        var mobileFinePrint = mobileForm.querySelector('.mobile-fine-print-wrapper');
        var inputMobileBorder = mobileForm.querySelector('.phone-input');
        var attentiveForm = mobileForm.querySelector(ATTENTIVE_FORM_SELECTOR);
        
        if (mobileFinePrint && inputMobileBorder) {
          mobileFinePrint.classList.remove('fade-in-text');
          inputMobileBorder.classList.remove('border');
          mobileFinePrint.classList.add(elements.hiddenClass);
          if (attentiveForm) {
            Footer.resetErrors(attentiveForm);
          }
        }
      }
    });
  };

  Footer.setupGlobalFormDelegation = function setupGlobalFormDelegation() {
    if (Footer._delegationSetup) {
      return;
    }
    Footer._delegationSetup = true;
    
    document.addEventListener('click', function(e) {
      var target = e.target;
      var form;
      
      // Handle Attentive form submissions
      if (target.matches(ATTENTIVE_SUBMIT_TRIGGER)) {
        form = target.closest(ATTENTIVE_FORM_SELECTOR);
        if (form) {
          Footer.attentiveSubmitHandler(e, target, form);
        }
      }
      
      // Handle Klaviyo form submissions
      if (target.matches(KLAVIYO_SUBMIT_TRIGGER)) {
        form = target.closest(KLAVIYO_FORM_SELECTOR);
        if (form) {
          Footer.klaviyoSubmitHandler(e, target, form);
        }
      }
    });
  };


  Footer.initGlobalFooter = function initGlobalFooter() {
    function initFooter() {
      var desktopSignUpSelector = "#signup-container-desktop";
      var mobileSignUpSelector = "#signup-container-mobile";
      var FooterNewsletter = window.theme.RS.FooterNewsletter;

      if (FooterNewsletter) {
        FooterNewsletter.initFooterSignUp(desktopSignUpSelector);
        FooterNewsletter.initFooterSignUp(mobileSignUpSelector);
        Footer.setupGlobalFormDelegation();
      }
    }

    document.addEventListener('DOMContentLoaded', initFooter);
  };

  document.dispatchEvent(loadedEvent);

  return Footer;
})();

// Initialize Footer Form
window.theme.RS.FooterNewsletter.initGlobalFooter();